import React from "react"
import Header from "./header"
import Footer from "./footer"
import "./layout.css"
import ProductComparisonBar from "./product-comparison-bar";
import { ClarityScript } from "../scripts/clarity";

const Layout = ({ children, pathname }) =>  (
  <div className="main">
    <Header />

    <div className="main-content">
      <main className="full-page">{children}</main>
      
      {!pathname?.startsWith('/porownywarka') && <ProductComparisonBar /> }
      {pathname === "/" ? <Footer homePage /> : <Footer /> }
      <ClarityScript />
    </div>
  </div>
);

export default Layout;
